import styled from "styled-components";

export const HotRecommendWrapper = styled.div`
	.recommend-list {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
`;
